// import _ from 'lodash';
import React, { useState } from 'react';
import Grid from '@mui/material/Grid';
import Box from '@mui/system/Box';
import Typography from '@mui/material/Typography';
import ListItem from '@mui/material/ListItem';
import ListItemText from '@mui/material/ListItemText';
import List from '@mui/material/List';
import ListItemAvatar from '@mui/material/ListItemAvatar';
import Avatar from '@mui/material/Avatar';
import OnlineUsersListModal from '../Modal/OnlineUsersListModal';

const WWMainbox = (props) => {
    console.log("WWMainbox onlineUsersData======>", props.onlineUsersData);
    const [confirmModal, setConfirmModal] = useState(false);
    const [usersData, setUsersData] = useState([]);

    const handleOnlineUsers = (userType) => {
        let userList = [];
        let userFinalList = [];
        setConfirmModal(true);
        if (userType == 'incharge') {
            userList = props.onlineUsersData.incharge;
        } else if (userType == 'learner') {
            userList = props.onlineUsersData.learner;
        } else if (userType == 'trainer') {
            userList = props.onlineUsersData.trainer;
        } else if (userType == 'staff') {
            userList = props.onlineUsersData.staff;
        }
        if (userList.length > 0) {
            userList.forEach((data, index) => {
                let userInfo = {};
                userInfo.uid = data.uid;
                userInfo.userName = data.nm;
                userFinalList.push(userInfo);
            });
            setUsersData(userFinalList);
        } else {
            setUsersData([]);
        }
    }

    return (
        <Grid container>
            <Grid item xs={12}>
                <Grid container sx={{
                    flexDirection: 'row', justifyContent: 'flex-start',
                }}>
                    <Grid item xs={12} sx={{}}>
                        <Box sx={{ backgroundColor: '#3eda00ff', px: 3, mt: 1, pt: 1, pb: 1, borderRadius: 5 }}>
                            <Grid container spacing={1}>
                                <Grid item xs={3} sx={{ px: 1, }}>
                                    <List
                                        dense
                                        sx={{ border: 1, borderRadius: 10, borderColor: '#FFF', padding: 0, my: 1, backgroundColor: '#FFF' }}>
                                        <ListItem
                                            onClick={() => { handleOnlineUsers('incharge') }}
                                        >
                                            {/* <img src={require('../../assets/teach_active.png')} width='18%' /> */}
                                            <ListItemText>
                                                <Typography sx={{
                                                    color: '#5f5600ff', pl: 1, fontSize: '1rem', fontWeight: '500', '@media (min-width: 1636px)': {
                                                        fontSize: "1.6rem",
                                                    }
                                                }}>
                                                    Incharge
                                                </Typography>
                                            </ListItemText>
                                            <ListItemAvatar >
                                                <Avatar sx={{ background: '#5f5600ff', width: 30, height: 30, float: 'right', fontSize: '0.9rem', fontWeight: 'bold', '@media (min-width: 1636px)': { fontSize: '1.4rem', width: 40, height: 40, } }}>{props.onlineUsersData.incharge.length}</Avatar>
                                            </ListItemAvatar>
                                        </ListItem>
                                    </List>
                                </Grid>
                                <Grid item xs={3} sx={{ px: 1, }}>
                                    <List dense sx={{ border: 1, borderRadius: 10, borderColor: '#FFF', padding: 0, my: 1, backgroundColor: '#FFF', }}>
                                        <ListItem onClick={() => { handleOnlineUsers('trainer') }}>
                                            {/* <img src={require('../../assets/teach_active.png')} width='18%' /> */}
                                            <ListItemText>
                                                <Typography variant="caption" sx={{
                                                    color: '#5f5600ff', pl: 1, fontSize: '1rem', fontWeight: '500', '@media (min-width: 1636px)': {
                                                        fontSize: "1.6rem",
                                                    }
                                                }}>
                                                    Trainer
                                                </Typography>
                                            </ListItemText>
                                            <ListItemAvatar >
                                                <Avatar sx={{ background: '#5f5600ff', width: 30, height: 30, float: 'right', fontSize: '0.9rem', fontWeight: 'bold', '@media (min-width: 1636px)': { fontSize: '1.4rem', width: 40, height: 40, } }}>{props.onlineUsersData.trainer.length}</Avatar>
                                            </ListItemAvatar>
                                        </ListItem>
                                    </List>
                                </Grid>
                                <Grid item xs={3} sx={{ px: 1, }}>
                                    <List dense sx={{ border: 1, borderRadius: 10, borderColor: '#FFF', padding: 0, my: 1, backgroundColor: '#FFF', }}>
                                        <ListItem onClick={() => { handleOnlineUsers('learner') }}>
                                            {/* <img src={require('../../assets/teach_active.png')} width='18%' /> */}
                                            <ListItemText>
                                                <Typography variant="caption" sx={{
                                                    color: '#5f5600ff', pl: 1, fontSize: '1rem', fontWeight: '500', '@media (min-width: 1636px)': {
                                                        fontSize: "1.6rem",
                                                    }
                                                }}>
                                                    Learner
                                                </Typography>
                                            </ListItemText>
                                            <ListItemAvatar >
                                                <Avatar sx={{ background: '#5f5600ff', width: 30, height: 30, float: 'right', fontSize: '0.9rem', fontWeight: 'bold', '@media (min-width: 1636px)': { fontSize: '1.4rem', width: 40, height: 40, } }}>{props.onlineUsersData.learner.length}</Avatar>
                                            </ListItemAvatar>
                                        </ListItem>
                                    </List>
                                </Grid>
                                <Grid item xs={3} sx={{ px: 1, }}>
                                    <List dense sx={{ border: 1, borderRadius: 10, borderColor: '#FFF', padding: 0, my: 1, backgroundColor: '#FFF', }}>
                                        <ListItem onClick={() => { handleOnlineUsers('staff') }}>
                                            {/* <img src={require('../../assets/teach_active.png')} width='18%' /> */}
                                            <ListItemText>
                                                <Typography variant="caption" sx={{
                                                    color: '#5f5600ff', pl: 1, fontSize: '1rem', fontWeight: '500', '@media (min-width: 1636px)': {
                                                        fontSize: "1.6rem",
                                                    }
                                                }}>
                                                    Staff
                                                </Typography>
                                            </ListItemText>
                                            <ListItemAvatar >
                                                <Avatar sx={{ background: '#e0e0e0', width: 30, height: 30, float: 'right', fontSize: '0.9rem', fontWeight: 'bold', '@media (min-width: 1636px)': { fontSize: '1.4rem', width: 40, height: 40, } }}>{props.onlineUsersData.staff.length}</Avatar>
                                            </ListItemAvatar>
                                        </ListItem>
                                    </List>
                                </Grid>
                            </Grid>
                        </Box>
                        <OnlineUsersListModal
                           title={'Online Users'}
                           visible={confirmModal}
                           toggleModal={(flag) => setConfirmModal(flag)}
                           options={usersData}
                        />
                    </Grid>
                </Grid>
            </Grid>
        </Grid>
    )
}
export default WWMainbox;